// The astrologer dashboard lives ONLY on its own host, partner.<domain> (partner.bvastro.com in production,
// http://partner.localhost:3000 in development). There is no path of the customer site that opens it.
// On that host the dashboard is the whole site, so its URLs are just /home, /login, ...
// www.partner.<domain> is treated the same as partner.<domain> (a "www." typed or DNS-configured in front of it
// shouldn't silently fall back to the customer site).
export const isPartnerHost = () =>
  typeof window !== 'undefined' && window.location.hostname.toLowerCase().replace(/^www\./, '').startsWith('partner.');

export const PATHS = {
  login: '/login',
  adminLogin: '/admin-login',
  home: '/home',
  sessionHistory: '/session-history',
  availability: '/availability',
  profile: '/profile',
  contact: '/contact-us',
  mis: '/mis',
  overview: '/overview',
  payments: '/payments',
  bookings: '/bookings',
  customers: '/customers',
  support: '/support',
  pricing: '/pricing',
};

export const paymentPath = (orderId) => `/payments/${encodeURIComponent(orderId)}`;
export const bookingPath = (bookingId) => `/bookings/${bookingId}`;
export const customerPath = (userId) => `/customers/${encodeURIComponent(userId)}`;
export const ticketPath = (ticketId) => `/support/${ticketId}`;

const trimSlash = (url) => String(url || '').replace(/\/+$/, '');

// The customer website's origin. The session lobby (/meeting/...) lives there, not on the partner host.
// REACT_APP_FRONTEND_URL is the customer site; without it, drop "partner." from the current host.
const siteOrigin = () =>
  trimSlash(process.env.REACT_APP_FRONTEND_URL) || window.location.origin.replace(/\/\/(www\.)?partner\./, '//');

// The dashboard's origin, from the customer site. REACT_APP_PARTNER_URL overrides it; otherwise it is the current host
// with "partner." in front (bvastro.com -> partner.bvastro.com, localhost:3000 -> partner.localhost:3000).
const partnerOrigin = () => {
  const configured = trimSlash(process.env.REACT_APP_PARTNER_URL);
  if (configured) return configured;
  const { protocol, host } = window.location;
  return `${protocol}//partner.${host.replace(/^(www|partner)\./, '')}`;
};

// The two sites are different origins, so links between them are always full URLs.
// `key` is the astrologer's private lobby key from the dashboard API; with it the lobby also shows what the customer shared.
export const lobbyUrl = (meetingUUID, key = '') => `${siteOrigin()}/meeting/${encodeURIComponent(meetingUUID)}?userType=astrologer${key ? `&k=${encodeURIComponent(key)}` : ''}`;
export const dashboardUrl = (path = PATHS.home) => `${partnerOrigin()}${path}`;
